<template>
    <modify-wrapper>
        <div class="join-row-wrap" style="width:1080px" v-if="me">
            <!-- 정보입력: 일반 -->
            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">기본정보</h3>
                </div>

                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <myinfo-row label="아이디">
                            <div class="d-flex align-center">{{ me.username }}</div>
                        </myinfo-row>
                        <myinfo-row label="비밀번호">
                            <v-text-field v-model="me.subPassword" type="password" name="" value="" outlined hide-details class="rounded-0" />
                            <small class="text-grey text-grey--right">(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)</small>
                        </myinfo-row>
                        <myinfo-row label="비밀번호 확인">
                            <v-text-field v-model="me.subPassword2" type="password" name="" value="" outlined hide-details class="rounded-0" />
                        </myinfo-row>
                        <myinfo-row v-if="isIndividual" label="이름">
                            <v-text-field v-model="me.name" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>
                        <myinfo-row v-if="isIndividual" label="소속/부서">
                            <v-text-field v-model="me.affiliation" type="text" class="rounded-0" outlined hide-details />
                        </myinfo-row>
                        <!-- 자문분야 / 관심분야 -->
                        <myinfo-areas v-model="me" :areas="areas" />
                    </div>
                </div>
            </div>

            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">공개정보</h3>
                </div>

                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <myinfo-row v-if="isSupporter" label="닉네임">
                            <v-text-field v-model="me.nickname" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>

                        <myinfo-row label="연락처">
                            <v-row align="center">
                                <v-col class="py-0">
                                    <v-select v-model="me.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details class="rounded-0"></v-select>
                                </v-col>
                                -
                                <v-col class="py-0">
                                    <v-text-field v-model="me.phone2" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                </v-col>
                                -
                                <v-col class="py-0">
                                    <v-text-field v-model="me.phone3" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                </v-col>
                            </v-row>
                        </myinfo-row>

                        <myinfo-row label="이메일">
                            <v-text-field v-model="me.email" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>
                        <template v-if="isSupporter">
                            <myinfo-row label="전문가 소개">
                                <v-textarea
                                    v-model="me.summary"
                                    type="text"
                                    class="rounded-0"
                                    outlined
                                    hide-details
                                    :placeholder="`기업에서 조회하는 전문가 검색 섹션에 표시되는 부분입니다.\n전문분야 및 경력사항을 소개형태로 50자 이상 작성 부탁드립니다.`"
                                />
                            </myinfo-row>
                            <myinfo-row label="사진">
                                <v-file-input v-model="me.avatar" dense hide-details outlined class="rounded-0" accept="image/*" />
                            </myinfo-row>
                        </template>
                        <template v-if="isExpert">
                            <myinfo-row>
                                <template slot="title">
                                    <div class="d-flex align-center"><span class="d-inline-block mr-1">정보공개동의</span><bottom-popup2 v-model="showEvent" /></div>
                                </template>
                                <!-- <v-row align="center">
                                    <v-col cols="auto">
                                        <v-switch label="검색노출" v-model="me.isDisplayed" inset class="ma-0 ml-1" />
                                    </v-col>
                                    <v-col cols="auto" class="ml-3"> -->
                                <v-switch label="연락처노출" v-model="me.isContactDisplayed" inset class="ma-0 ml-1" />
                                <!-- </v-col>
                                </v-row> -->
                            </myinfo-row>
                        </template>
                    </div>
                </div>
            </div>
            <modify-form-description v-model="me" />

            <v-row align="center" justify="center" style="margin-bottom:3rem">
                <button class="button button--border-primary" @click="$store.dispatch('logout')">
                    <span>로그아웃</span>
                </button>
                <button class="button button--primary ml-4" @click="save">
                    <span>저장</span>
                </button>
            </v-row>
        </div>
        <daum-postcode ref="daumPostcode" @change="({ postcode, address }) => Object.assign(me, { postcode, address1: address })"></daum-postcode>
    </modify-wrapper>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/data/CONSTANTS";

import MyinfoRow from "@/components/client/mypage/myinfo-row.vue";
import FormFiles from "@/components/client/join/skin/form-files.vue";
import BottomPopup2 from "../../join/skin/USER_INDIVIDUAL/bottom-popup2.vue";
import MyinfoAreas from "@/components/client/mypage/myinfo-areas.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import ModifyWrapper from "./modify-wrapper.vue";
import MyinfoUsertype from "@/components/client/mypage/myinfo-usertype.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import ModifyFormDescription from "./modify-form-description.vue";

export default {
    components: {
        MyinfoRow,
        FormFiles,
        BottomPopup2,
        MyinfoAreas,
        DaumPostcode,
        ModifyWrapper,
        MyinfoUsertype,
        MypageNavigation,
        ModifyFormDescription,
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        phone() {
            return this.phone1 && this.phone2 && this.phone3 ? [this.phone1, this.phone2, this.phone3].join("-") : undefined;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isIndividual() {
            return this.me?.type == USER_TYPES.INDIVIDUAL;
        },
        isOrganization() {
            return this.me?.type == USER_TYPES.ORGANIZATION;
        },
        isSupporter() {
            return this.me?.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
        isExpert() {
            return this.me?.isExpert;
        },
        toExpert() {
            const type = this.isOrganization ? "organization" : "individual";
            const _expert = this.payload._user;
            return `/experts/${type}/${_expert}`;
        },
    },
    data() {
        return {
            showEvent: true,
            me: null,
            areas: [],
        };
    },
    methods: {
        async init() {
            try {
                var { user } = await api.v1.me.get();
                var [phone1, phone2, phone3] = (user.phone || "").phoneNumberFormat().split("-");
                const avatar = user?.avatar?.url ? await api.getResource(user.avatar.url, true) : null;
                const brochures = await Promise.all((user?.brochures || [])?.map(async ({ url }) => api.getResource(url, true)));

                if (user?.kind !== INDIVIDUAL_KINDS.SUPPORTER.value) {
                    alert("권한이 없습니다.");
                    this.$store.dispatch("logout");
                    this.$router.go();
                }

                this.me = {
                    ...user,
                    phone1,
                    phone2,
                    phone3,
                    avatar,
                    brochures,
                    establishedAt: user.establishedAt?.toDate(),
                };

                var { areas } = await api.v1.areas.gets();
                this.areas = areas;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        reset() {
            this.me = null;
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");
            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");
        },

        validate() {
            try {
                if ((this.me.subPassword || this.me.subPassword2) && this.me.subPassword != this.me.subPassword2) throw new Error("비밀번호 및 비밀번호확인이 일치하지 않습니다");
                if (this.me.subPassword && this.me.subPassword2) this.checkPassword(this.me.subPassword);

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                const _user = this.me._id;

                if (this.me?._avatar) {
                    await api.v1.users.avatar.delete({ _id: this.me._avatar, _user });
                }

                for (const _id of this.me?._brochures || []) {
                    await api.v1.users.brochures.delete({ _id, _user });
                }

                await api.v1.me.put({
                    ...this.me,
                    subPassword: this.me.subPassword ? CryptoAES.encrypt(this.me.subPassword) : undefined,
                    subPassword2: undefined,
                    _brochures: undefined,
                    brochures: undefined,
                });

                if (this.me?.avatar) {
                    await api.v1.users.avatar.post({ _user }, this.me.avatar);
                }

                if (this.me?.brochures?.length) {
                    for (const [index, brochure] of this.me.brochures.entries()) {
                        await api.v1.users.brochures.post({ _user, index }, brochure);
                    }
                }

                alert("수정되었습니다");
                this.$router.go();
            }
        },
    },
    mounted() {
        if (this.accessToken) this.init();
    },
    watch: {
        accessToken() {
            if (this.accessToken) this.init();
            else this.reset();
        },
        "me.phone1"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone2"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone3"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
    },
};
</script>
<style lang="scss" scoped>
.modify-form-wrapper {
    max-height: 100vh;
    overflow-y: auto;
}
</style>
